module.exports = "images/favicon.ico";